import { IOfferingsListItem } from 'legacy/lut/features/partner360/jbpSettings/models/offeringsListItem'

import { parseRawSetting } from '../helpers/parseRawSetting'
import { IParsedOfferingsListItem } from '../models/parsedOfferingsList'

export const mapOfferingsList = (rawOfferingsList: string): IOfferingsListItem[] => {
  const parsedOfferingsList = parseRawSetting<IParsedOfferingsListItem[]>({
    setting: rawOfferingsList,
    defaultValue: [],
  })

  return parsedOfferingsList.map((it) => ({
    id: it.Id,
    offering: it.Offering,
    orderBy: it.OrderBy,
    rtm: it.RTM,
    translationKey: it.TranslationKey,
  }))
}
